import { TaggedError } from "@for-it/domain-lib";
export class AssignmentNotFound extends TaggedError {
    constructor() {
        super("AssignmentNotFound");
    }
}
